module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large@3x.27f9e926.png";